import styled from 'styled-components';
import {ModalPdf} from '../TicketGroup/styles';

export const OrderPdfDialog = styled(ModalPdf)`
  height: auto;
  .ant-modal-body > div {
    padding: 32px 0 28px;
  }
`;

export const OrderPdfInput = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 0 20px;
  margin-bottom: 16px;
  box-sizing: border-box;
  button:not(:disabled) {
    color: ${({theme}) => theme.palette.common.white} !important;
  }
`;

export const OrderPdfSummary = styled.div`
  font-size: 12px;
  width: 100%;
  padding: 0 20px;
  margin-bottom: 16px;
  box-sizing: border-box;
`;
